export const getExplanatoryTexts = (
    rama: number,
    articulo: number,
    plan: number,
    quotationTexts?: Record<string, string>
  ): string => {

    if (!quotationTexts || typeof quotationTexts !== "object") return "";
  
    const key = `${rama}-${articulo}-${plan}`;
    const fallbackKey = `${rama}-${articulo}-000`;
  
    return quotationTexts[key] || quotationTexts[fallbackKey] || "";
  };